import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { callAPI, Method, updateMainHeader, } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import WSButton from "../../../Components/Button/WSButton";
import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";
import WSSelectField from "../../../Components/Select/WSSelect";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import WSTextField from "../../../Components/TextBox/WSTextBox";

export const Symptoms: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const [loadingSaveAndNew, setLoadingSaveAndNew] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { showMessage } = useSnackbar();
  const params = useParams();
  const id = params?.id;
  useEffect(() => {
    updateMainHeader("Symptoms");
  });

  breadCrumbsStore.updateBreadCrumbs([
    { "Symptom List": "/symptoms/list" },
    { [!id ? "Add Symptom" : "Update Symptom"]: "/symptoms/create" },
  ]);

  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getSpecializationById(id: any) {
      try {
        const response: any = await callAPI("Symptoms", Method.GET, {}, id);
        if (response && response?.data) {
          setValue("symptom", response.data?.symptom);
          setValue("specializationId", response.data?.specializationId);
          setValue("id", response.data?.id);
        }
      } catch (error) {
        console.log("failed to retrieve data", error);
      }
    }
    if (id) {
      getSpecializationById(id);
    }
  }, [id, setValue]);

  const handleDataSaveAndNew = async (data: any) => {
    try {
      setLoadingSaveAndNew(true);
      const response: any = await saveData(data);
      if (response && response?.message) {
        showMessage(
          response.message,
          response.success === true ? "success" : "error"
        );
        if (response.success === true) {
          reset();
        }
      } else if (response?.id) {
        reset();
      }
    } catch (e: any) {
      showMessage(e.error);
    } finally {
      setLoadingSaveAndNew(false);
    }
  };
  const handleData = async (data: any) => {
    try {
      setLoading(true);
      const response: any = await saveData(data);
      if (response && response?.message) {
        showMessage(
          response.message,
          response.success === true ? "success" : "error"
        );
        if (response.success === true) {
          navigate(`/symptoms/list`);
        }
      } else if (response?.id) {
        showMessage("symptoms Created Successfully", "success");
        navigate(`/symptoms/list`);
      }
    } catch (e: any) {
      showMessage(e.error);
    } finally {
      setLoading(false);
    }
  };

  const saveData = async (data: any) => {
    const request: any = {
      symptom: data?.symptom || "",
      specializationId: data?.specializationId
    };
    if (data?.symptomId) {
      const response: any = await callAPI(
        "Symptoms",
        Method.PUT,
        request,
        data.symptomId
      );
      return response;
    } else {
      const response: any = await callAPI("Symptoms", Method.POST, request);
      return response;
    }
  };
  const specilaisationsSource = {
    url: "Specialization/search",
    page: 1,
    pageSize: 1000000,
    filter: [],
    sort: [],
  };
  const transFormDataSpecialisation = (data: any) => {
    const specilazation: Array<any> = [];
    if (data) {
      data.map((item: any) => {
        specilazation.push({ label: item.specializations, value: item.id });
      });
    }
    return specilazation;
  };
  const handleCancelClick = () => {
    navigate("/symptoms/list");
  };
  return (
    <Grid p={3}>
      <form onSubmit={handleSubmit(handleData)}>
        {/* <Grid item xs={12}>
          <HeaderList
            title="Symptoms"
            type="card"
            position="relative"
            isBackButton={true}
            url="/symptoms/list"
          />
        </Grid> */}

        <Grid
          sx={{
            padding: 4,
            backgroundColor: "#fff",
            borderRadius: 2,
            border: "1px solid lightgrey",
            marginTop: 3,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Name"}
                {...register("symptom")}
                id="symptom"
                name="symptom"
                control={control}
                rules={{ required: true }}
              />
              <WSHiddenField
                control={control}
                name="symptomId"
                defaultValue={id}
              />
            </Grid>
            <Grid item sm={6}>
              <Grid item xs={12} sm={12}>
                <WSSelectField
                  rules={{ required: true }}
                  id="specializationId"
                  control={control}
                  source={specilaisationsSource}
                  transFormData={transFormDataSpecialisation}
                  setValue={setValue}
                  label="Specialization"
                  name="specializationId"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
          <Grid item>
            <WSButton
              id="cancel"
              type="button"
              label="Cancel"
              size="medium"
              onClick={handleCancelClick}
              variant="outlined"
              color="primary"
              sx={{
                borderRadius: 8,
                width: "8rem",
                border: "1px solid #098963",
                color: "#098963",
                backgroundColor: "#FFFFFF",
              }}
            />
          </Grid>
          {!id &&
            <Grid item>
              <WSButton
                id="submit"
                type="submit"
                label="Save & New"
                size="medium"
                variant="outlined"
                color="primary"
                loading={loadingSaveAndNew}
                onClick={handleSubmit(handleDataSaveAndNew)}
                sx={{
                  borderRadius: 8,
                  width: "8rem",
                  border: "1px solid #098963",
                  color: "#FFFFFF",
                  backgroundColor: "#098963",
                  "&:hover": {
                    backgroundColor: "#066e4f",
                  },
                }}
              />
            </Grid>
          }
          <Grid item>
            <WSButton
              id="submit"
              type="submit"
              label="Save"
              size="medium"
              variant="outlined"
              color="primary"
              onClick={handleSubmit(handleData)}
              loading={loading}
              sx={{
                borderRadius: 8,
                width: "8rem",
                border: "1px solid #098963",
                color: "#FFFFFF",
                backgroundColor: "#098963",
                "&:hover": {
                  backgroundColor: "#066e4f",
                },
              }}
            />
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
});
